import { useState } from "react";
import { Form } from "react-router-dom";

// 引入 pubsub-js

// 引入 icon
import { PlusCircleIcon } from "@heroicons/react/24/outline";

// 引入 utilitiesverifyExpense
import { verifyExpense } from "../utilities";

// --- 底下開始撰寫 ---

export default function AddExpense(props) {
  const { category, categoryName, categoryColor } = props;

  const [formData, setFormData] = useState({
    expenseName: "",
    expenseAmount: "",
    expenseCategory: category?.[0]?.category_id || "",
  });
  const [errorMsg, setErrorMsg] = useState({});

  // useEffect(() => {
  //     // 訂閱事件
  //     const token = PubSub.subscribe('updateCategory', (_, data) => {
  //         // 當事件觸發時，更新狀態
  //         setFormData((prevState)=>({
  //             ...prevState,
  //             expenseCategory:data
  //         }));
  //     });

  //     // 清理訂閱
  //     return () => {
  //         PubSub.unsubscribe(token);
  //     };
  // }, []);

  function handleChange(e) {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  }

  function handleSubmit(e) {
    const verifyResult = verifyExpense(formData);

    if (verifyResult) {
      e.preventDefault();
      setErrorMsg(verifyResult);
    } else {
      setFormData({
        expenseName: "",
        expenseAmount: "",
        expenseCategory: category?.[0]?.category_id || "",
      });
      setErrorMsg({});
    }
  }

  return (
    <div
      id="addExpense"
      className="bg-lightAccent1 border border-gray-200 p-6 rounded-2xl space-y-4"
    >
      <h3 className="mb-2 text-2xl">
        {categoryName ? (
          <>
            <span style={{ color: categoryColor }}>{categoryName}</span>的項目
          </>
        ) : (
          "項目"
        )}
      </h3>

      <Form method="post" onSubmit={handleSubmit}>
        <div className="border-dashed p-6 rounded-lg flex flex-col gap-4">
          <div className="flex gap-4">
            <div className="flex flex-col gap-1">
              <label htmlFor="" className="font-light">
                項目名稱
              </label>
              <input
                type="text"
                name="expenseName"
                value={formData.expenseName}
                onChange={handleChange}
                placeholder="如: 咖啡, 火車, 窗簾..."
                className="input-primary"
              />
              <p className="text-warning text-sm">
                {errorMsg.expenseName?.[0]}
              </p>
            </div>
            <div className="flex flex-col gap-1">
              <label htmlFor="" className="font-light">
                項目金額
              </label>
              <input
                type="number"
                min={0}
                step={1}
                name="expenseAmount"
                value={formData.expenseAmount}
                onChange={handleChange}
                placeholder="如: 50,100,500..."
                className="input-primary"
              />
              <p className="text-warning text-sm">
                {errorMsg.expenseAmount?.[0]}
              </p>
            </div>
          </div>
          <div className="flex flex-col gap-1">
            <label htmlFor="" className="font-light">
              項目類別
            </label>
            <select
              name="expenseCategory"
              className="input-primary"
              value={formData.expenseCategory} // select 的 value 與 option 的 value 匹配的話，預設就會是該 option
              onChange={handleChange}
            >
              {category.map((item) => {
                return (
                  <option key={item.category_id} value={item.category_id}>
                    {item.category_name}
                  </option>
                );
              })}
            </select>
            <p className="text-warning text-sm">{errorMsg.expenseCategory}</p>
          </div>

          {/* action 判斷點 */}
          <input type="hidden" name="_action" value="add_new_expense" />

          <button className="btn-primary items-center gap-1 mx-auto">
            <span>新增項目</span>
            <PlusCircleIcon width={24} />
          </button>
        </div>
      </Form>
    </div>
  );
}
